import axios from 'axios'
import clsx from 'clsx'
import {useFormik} from 'formik'
import {stringify} from 'querystring'
import {useEffect, useRef, useState} from 'react'
import * as Yup from 'yup'
import {UniqueWalletAccNo} from '../../components/UniqueWalletAccNo'
import {sortByName} from '../../components/SortByName'
import {ErrorHandling} from '../../components/ErrorHandling'
import {useAuth} from '../../auth'
import Select from 'react-select'
import {customStyles} from '../../components/CustomStyles'

export default function Wallet_Transaction_Summary_Refresh_Modal(props: any) {
  const session: any = localStorage.getItem('kt-auth-react-v')?.replace(/"/g, '')
  const {logout} = useAuth()
  const SISPAY_API = String(process.env.REACT_APP_SISPAY_API)
  const [loading, setLoading] = useState(false)
  const [walletAccNoList, setWalletAccNoList] = useState([])
  const [selectWalletAccNoListBtnRefresh, setSelectWalletAccNoListBtnRefresh] = useState(false)

  const selectWalletAccNoListBtn = useRef<any>()
  const modalCloseBtn = useRef<any>()

  function retrieveWalletAccNo(SISPAY_API: string, url: string, location: string) {
    setSelectWalletAccNoListBtnRefresh(true)
    axios
      .post(
        `${SISPAY_API}${url}`,
        {
          request: {
            session: session,
          },
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then(function (response) {
        if (response.data.code == 200) {
          let walletAccNoList = response.data.result[`${location}`]

          if (formik.values.walletCd) {
            walletAccNoList = walletAccNoList.filter(
              (item: any) => item.walletCd === formik.values.walletCd
            )
          }

          walletAccNoList = UniqueWalletAccNo(walletAccNoList)

          setWalletAccNoList(sortByName(walletAccNoList, 'label'))
          setSelectWalletAccNoListBtnRefresh(false)
        } else {
          ErrorHandling(response, logout)
        }
      })
      .catch(function (error) {})
  }

  function resetModal() {
    setLoading(false)
    setSelectWalletAccNoListBtnRefresh(false)
    formik.resetForm()
  }

  const initialValues = {
    walletCd: '',
    walletAccNo: '',
  }

  const addUserSchema = Yup.object().shape({
    walletCd: Yup.string().required('Wallet Code is required'),
    walletAccNo: Yup.string().required('Wallet Account Number is required'),
  })

  const formik = useFormik({
    initialValues,
    validateOnChange: true,
    enableReinitialize: true,
    validationSchema: addUserSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)

      let walletCd = values.walletCd.trim()
      let walletAccNo = values.walletAccNo.trim()

      try {
        axios
          .post(
            `${SISPAY_API}/wallet/transactionsummary/refresh`,
            {
              request: {
                session: session,
                getAll: false, // Currently hardcorded to false
                walletCd: walletCd,
                walletAccNo: walletAccNo, // required only when getAll is false
              },
            },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(function (response) {
            setLoading(false)
            if (response.data.code == 200) {
              alert(response.data.message)
              modalCloseBtn.current.click()
            } else {
              ErrorHandling(response, logout)
            }
          })
          .catch(function (error) {})
      } catch (error) {}
    },
  })

  useEffect(() => {
    retrieveWalletAccNo(SISPAY_API, '/wallet/list', 'wallet')
    formik.setFieldValue('walletAccNo', '')
  }, [formik.values.walletCd])

  return (
    <div
      className='modal fade'
      id='walletTransactionSummaryRefreshModal'
      data-bs-backdrop='static'
      data-bs-keyboard='false'
      tabIndex={-1}
      aria-labelledby='staticBackdropLabel'
      aria-hidden='true'
    >
      <div className='modal-dialog modal-dialog-centered'>
        <form onSubmit={formik.handleSubmit} className='m-10'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h1 className='modal-title fs-5' id='staticBackdropLabel'>
                Manual extract Nagad and Bkash report
              </h1>
              <button
                ref={modalCloseBtn}
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={() => resetModal()}
              ></button>
            </div>
            <div className='modal-body'>
              <div className='fv-row mb-8'>
                <label className='form-label required fw-bolder text-dark fs-6'>Wallet Code</label>
                <select
                  {...formik.getFieldProps('walletCd')}
                  className={clsx(
                    'form-control bg-transparent',
                    {
                      'is-invalid': formik.touched.walletCd && formik.errors.walletCd,
                    },
                    {
                      'is-valid': formik.touched.walletCd && !formik.errors.walletCd,
                    }
                  )}
                  data-placeholder=''
                >
                  <option value=''>Please Select</option>
                  <option value='BKASH'>BKASH</option>
                  <option value='NAGAD'>NAGAD</option>
                </select>
              </div>{' '}
              <div className='fv-row mb-5'>
                <label className='form-label fw-bolder text-dark fs-6'>Wallet Account Number</label>
                <Select
                  ref={selectWalletAccNoListBtn}
                  isDisabled={
                    formik.values.walletCd == '' || selectWalletAccNoListBtnRefresh ? true : false
                  }
                  isLoading={selectWalletAccNoListBtnRefresh}
                  styles={customStyles}
                  className='basic-single'
                  classNamePrefix='select'
                  name='walletAccNo'
                  options={walletAccNoList}
                  isClearable={true}
                  value={
                    formik.values.walletAccNo
                      ? {value: formik.values.walletAccNo, label: formik.values.walletAccNo}
                      : null
                  }
                  onChange={(e: any) =>
                    e !== null
                      ? formik.setFieldValue('walletAccNo', e.value)
                      : formik.setFieldValue('walletAccNo', '')
                  }
                />
              </div>{' '}
            </div>
            <div className='modal-footer'>
              <button
                type='button'
                className='btn btn-secondary'
                data-bs-dismiss='modal'
                onClick={() => resetModal()}
              >
                Close
              </button>
              {/* <button
                type='button'
                className='btn btn-primary'
                data-bs-dismiss='modal'
                onClick={() => {}}
              >
                Refresh
              </button> */}
              <button
                type='submit'
                id='kt_sign_up_submit'
                className='btn btn-lg btn-primary'
                disabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
                onClick={() => {}}
              >
                {!loading && <span className='indicator-label'>Extract</span>}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    Please wait...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>{' '}
        </form>
      </div>
    </div>
  )
}
